export enum MetricGroup {
  Delivery = 'Delivery',
  Pacing = 'Pacing',
  Financial = 'Financial',
}

export default MetricGroup;
